import * as React from 'react';
import { SVGProps } from 'react';
export const CaretDownIcon = (props: SVGProps<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props} data-sentry-element="svg" data-sentry-component="CaretDownIcon" data-sentry-source-file="CaretDown.tsx">
    <path d="m17 10-5 6-5-6h10Z" fill={props.fill || `currentColor`} data-sentry-element="path" data-sentry-source-file="CaretDown.tsx" />
  </svg>;